import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7528c2fd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528c2fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7528c2fd')) {
      api.createRecord('7528c2fd', component.options)
    } else {
      api.reload('7528c2fd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7528c2fd&scoped=true&", function () {
      api.rerender('7528c2fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/logistics-city-store-manage/modules/product-supplement-dialog/index.vue"
export default component.exports